import { API_URI } from "@/helpers/config";

export default class Event {
    constructor(data) {
        Object.assign(this, data);
    }
    get fullImage() {
        const model = this;
        if (! model.image) return null;
        return API_URI + "/" + model.image;
    }
    get thumbnail() {
        const model = this;
        if (! model.image) return null;
        const thumb = model.image.replace('sites/default/files/', 'sites/default/files/imagecache/artwork_thumb/');
        return API_URI + "/" + thumb;
    }
}
